// extracted by mini-css-extract-plugin
export var container = "_ix-0";
export var segment = "_ix-2";
export var segmentActive = "_ix-3";
export var track = "_ix-1";